import React from 'react'
import Card from 'react-bootstrap/Card';
import { Button } from 'react-bootstrap';
import '../mysass.scss';
import { Carousel } from 'react-bootstrap';
import {
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';

const Nature = () => {
  return (
<>
<br></br>
<div className='anchorsnature' id='nature' style={{textAlign:'center',fontSize:'16px'}}>
     Some nature places of <b>KOSOVO</b>:
    </div>


      {/* <br></br> */}


<MDBRow  className=' m-1 row-cols-1 row-cols-md-3 g-4'>

      <MDBCol >
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}}>
            
      <Carousel.Item>
      <Card.Img className='natureimages' src="hiking1.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Hiking</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Bogë, Rugovë</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Bogë is a small mountainous village and also a holiday resort village in western Kosovo. Bogë is located in the Accursed Mountains (also known as Albanian Alps) mountain range on an altitude of about 1,300m - 1,400m.             </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="hiking.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Hiking</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Gjeravica</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Kosovo's unspoiled Rugova Mountains are a prime hiking area. Gjeravica is a natural wonder that is one of the most popular holiday attractions in Kosovo for a reason.            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>

      <Carousel.Item >
      <Card.Img className='natureimages' src="hiking2.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Hiking</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Prevallë, Sharr Mountains</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Prevalla is a village in the Prizren municipality in Kosovo. Prevalla is located in the south of Kosovo in the Sharr Mountains on the southern slope of the Oshlak at around 1500 m, almost 30 kilometers from Prizren and about twelve kilometers from Brezovica , the largest ski center in Kosovo.
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
    </Carousel>
    </Card>
      </MDBCol>


      <MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}} >
      <Carousel.Item>
      <Card.Img className='natureimages' src="skiing.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Skiing</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Brod, Dragash</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            About 1 hour away, in the south-west of the city of Prizren, there is the tourist village of Brod, where you will have the opportunity to experience the valley of this place, and the high peaks of the mountains, ideal for winter sports, where you can also use the cable car lately.            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="skiing1.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Skiing</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Brezovica</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Top rated Brezovica is perfect for skiing and snowboarding where 15.6 km of slopes are available. 9 lifts transport the guests. The winter sports area is at an altitude of 1,718 to 2,522 m.            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
    </Carousel>
    </Card>
      </MDBCol>


      <MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}} >
      <Carousel.Item>
      <Card.Img className='natureimages' src="camping1.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Camping</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Rugova Valley</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            In addition to those who prefer to camp in tents, there are also many mountain cabins that offer accommodation. Many of the mountain cottages that offer accommodation are located along the Accursed Mountains, such as in the village of Bogë and other villages of Rugova (Rugova 93 km from Pristina) in western Kosovo.            
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="camping.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Camping</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Rugova Valley</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            In addition to those who prefer to camp in tents, there are also many mountain cabins that offer accommodation. Many of the mountain cottages that offer accommodation are located along the Accursed Mountains, such as in the village of Bogë and other villages of Rugova (Rugova 93 km from Pristina) in western Kosovo.            
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
    </Carousel>
    </Card>
      </MDBCol>



      <MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}} >
      <Carousel.Item>
      <Card.Img className='natureimages' src="biking.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Biking</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Germia Park, Prishtinë</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Whether you choose the Gërmia National Park or along the Badovc Lake you will experience the most attractive paths for biking. You may choose a bike for rent and wonder by yourself or be joined by a guided tour by professionals.            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="biking1.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>Biking</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Artanë, Novobërdë</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            For those who prefer longer cycling routes, we have a great recommendation, you can start the trail ride starting from Pristina, Germia, to Mramor village and then continuing to Artane Novoberde.            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
    </Carousel>
    </Card>
      </MDBCol>



      <MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px'}} >
      <Carousel.Item>
      <Card.Img className='natureimages' src="climbing1.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Climbing</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Rugova Canyon</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            One of the many activities you can do during your stay in Kosovo, particularly those of extreme sports, is climbing the rocks of the mountains in the Rugova gorge (Via Ferrata), west of the city of Peja, at the entrance to the Rugova gorge.            
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="climbing.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-dark" size="lg" style={{fontWeight:'500'}}>Climbing</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Rugova Canyon</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            One of the many activities you can do during your stay in Kosovo, particularly those of extreme sports, is climbing the rocks of the mountains in the Rugova gorge (Via Ferrata), west of the city of Peja, at the entrance to the Rugova gorge.            
            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
    </Carousel>
    </Card>
      </MDBCol>


      <MDBCol>
            <Card className="bg-dark text-white">
          <Carousel interval={5000} fade style={{height:'500px',width:'auto'}} >
            
          <Carousel.Item >
      <Card.Img className='natureimages' src="caving2.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Caving</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Gadime Cave, Lipjan</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            The Gadime stalactite cave is a limestone cave in the village of Gadime e Ulët in the municipality of Lipjan in Kosovo. The cave is 1,260 meters long. For vacation tourists, however, it is only possible to see the first 500 meters of the cave, as the rest of the cave is not yet accessible.</MDBCardText>
          </MDBCardBody>
      </Carousel.Item>

      <Carousel.Item>
      <Card.Img className='natureimages' src="caving.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Caving</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Sleeping Beauty, Radac</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Radavci (Sleeping Beauty) located near the village of Radavc, about 15 kilometers north-west of the city of Peja, and is located near the source of the Drini i Bardhë river (a place you must pay a visit).            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>
      
      
      <Carousel.Item >
      <Card.Img className='natureimages' src="caving1.jpg" alt="Card image"  />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      <Button className='naturebutton' variant="outline-light" size="lg" style={{fontWeight:'500'}}>Caving</Button>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Queen's Cave, Rugovë</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Many caves are in Rugova gorge.
Learn the history of the Queen's and King’s Caveswhile enjoying the adventure of Via Ferrata over the Lumbardh River of Peja.            </MDBCardText>
          </MDBCardBody>
      </Carousel.Item>

    </Carousel>
    </Card>
      </MDBCol>

      {/* ë */}
    </MDBRow>




    <br></br>
    <br></br>
<div id='nature' style={{textAlign:'center',fontSize:'16px'}}>
     Some places worth visiting:
    </div>


      {/* <br></br> */}

      <MDBRow className='m-1 row-cols-1 row-cols-md-3 g-4'>

  
      <MDBCol>
            <Card className="bg-dark text-white" style={{height:'500px'}}>
      <Card.Img className='natureimages' src="mirusha.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Mirusha Waterfalls</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            16 Mirusha waterfalls extend over a length of ten kilometers in an east-west direction and lie at an altitude of 480 to 400 meters. Even in winter, a trip to the park is worthwhile, because the waterfalls are also a spectacle when frozen.            </MDBCardText>
          </MDBCardBody>
    </Card>
      </MDBCol>

      <MDBCol>
            <Card className="bg-dark text-white" style={{height:'500px'}}>
      <Card.Img className='natureimages' src="drin.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>White Drin Waterfalls</MDBCardTitle>
            <MDBCardText style={{fontSize:'13px'}}>
            The natural beauty of the "White Drin Waterfalls" undoubtedly make this place a great tourist attraction in Kosovo. The springs of the Drin River make the village of Radavc a popular destination for excursions. The wild natural game of the White Drin when observed will leave great impression.            </MDBCardText>
          </MDBCardBody>
    </Card>
      </MDBCol>

      <MDBCol>
            <Card className="bg-dark text-white" style={{height:'500px'}}>
      <Card.Img className='natureimages' src="shpellakusarit.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Kusari Cave, Gjakovë</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Its antiquity is thought to be very early. Currently, it has three entrances, but with the adjustment of the infrastructure to reach the place in question, by the Municipality of Gjakova, which has also adjusted the paths that lead to the cave, it is thought that after this action, more visitors and searches can also be done by speleologists to see if its interior is bigger or not.            </MDBCardText>
          </MDBCardBody>
    </Card>
      </MDBCol>
      </MDBRow>






</>
  )
}

export default Nature